import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';
import { HtmlTemplateVar } from '../../dto/templates/html-template-var';
import { HtmlTemplate } from '../../dto/templates/html-template';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InvoicePdfTemplatesService {

  readonly apiPath = 'invoice-pdf-templates/';
  constructor(
      private http: HttpClient,
  ) {
   }

  getMany(): Observable<DataListModel<HtmlTemplate>> {
    return this.http.get(this.apiPath) as Observable<DataListModel<HtmlTemplate>>;
  }

  get(id: number): Observable<HtmlTemplate> {
    return this.http.get(this.apiPath + id) as Observable<HtmlTemplate>;
  }

  getVars(): Observable<DataListModel<HtmlTemplateVar>> {
    return this.http.get(this.apiPath + 'vars') as Observable<DataListModel<HtmlTemplateVar>>;
  }

  add(item: HtmlTemplate): Observable<number> {
      return this.http.post(this.apiPath, item) as Observable<number>;
  }

  update(id: number, item: HtmlTemplate): Observable<Object> {
      return this.http.put(this.apiPath + id, item);
  }

  delete(id: number): Observable<Object> {
    return this.http.delete(this.apiPath + id);
  }

  restore(id: number): Observable<Object> {
    return this.http.patch(this.apiPath + id, null);
  }

  deleteMany(list: number[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  restoreMany(list: number[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }
}
